import { useEffect, useState } from "react";
import { lista } from "../services/seguros";
import { dominioPoliza } from "../shared/seguroFicha";

/* Todas las pólizas de una vez, por dominio normalizado, para la columna
 * «Seguro» de Tractores y Furgones. Una sola lectura de `poliza_hub` (sin la
 * carátula) al abrir la pantalla, no una por fila.
 *
 * `undefined` mientras carga, sin permiso o si no se pudo leer: la columna no
 * se dibuja, porque «Sin cargar» en todas las filas sería inventar. */
export default function usePolizas(activo = true) {
  const [polizas, setPolizas] = useState(undefined);
  useEffect(() => {
    if (!activo) return undefined;
    let vigente = true;
    Promise.resolve(lista())
      .then((r) => {
        if (!vigente || !r || r.error) return;
        const m = new Map();
        for (const f of r.filas || []) {
          const d = dominioPoliza(f.dominio);
          if (d) m.set(d, f);
        }
        setPolizas(m);
      })
      .catch(() => {});
    return () => {
      vigente = false;
    };
  }, [activo]);
  return polizas;
}
